<template>
  <div class="view-my-requests">
    <div class="workload-data">
      <div class="workload-list mt-4 mx-3">
        <material-card color="orange" text="List of Onboarding Requests">
          <v-progress-linear v-if="loadingRequest" v-slot:progress color="orange" indeterminate></v-progress-linear>
          <v-data-table
            :headers="onboardingRequestsHeaders"
            :items="onboardingRequests"
            :pagination.sync="pagination"
            v-model="selected"
            item-key="Onboarding_Id"
            select-all
            no-data-text="No workload available"
            disable-initial-sort
          >
            <template v-slot:items="props">
              <tr :active="props.selected">
                <td>
                  <Can I="manage" a="oppreg">
                    <v-checkbox v-model="props.selected" color="orange" hide-details></v-checkbox>
                  </Can>
                </td>
                <td>
                  <span>{{ props.item.Acct_ID }}</span>
                </td>
                <td>
                  <v-icon
                    small
                    title="Edit"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="onEditOnboardingAccount(props.item)">edit</v-icon>
                  <v-icon
                    small
                    title="Clone"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="cloneRequest(props.item)">folder_shared</v-icon>

                  <v-icon small title="Bulk Clone" class="mr-2" color="primary" flat @click="cloneAccount(props.item)">folder_shared</v-icon>

                </td>
                <td>{{ props.item.Acct_name }}</td>
                <td>{{ props.item.Onboarding_Status }}</td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </div>
    </div>
    <!-- Update Request AWS Acct Dialog -->
    <v-dialog large v-model="updateAccount.showDialog" persistent scrollable max-width="1300px">
      <v-card>
        <v-card-title>
          <span v-if="updateAccount.fields.Onboarding_Status === 'New'">Update AWS Account</span>
          <span v-else>View AWS Account</span>
        </v-card-title>
        <v-card-text id="update-dialog-content">
          <v-container>
            <v-form ref="generalForm" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 xl12>
                  <div style>
                    <v-text-field
                      readonly
                      label="Calculated Account Name"
                      placeholder="AWS-PPA-CUSTOMERNAME-SHORTNAME"
                      v-model="generateAcctName"
                    />
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 xl12>
                  <v-stepper non-linear>
                    <v-stepper-header >
                      <v-stepper-step editable step="1">Validation</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step editable step="2">Questionnaire</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step step="3" editable>Contact Information</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                      <!-- VALIDATION SECTION -->
                      <v-stepper-content step="1">
                        <div>
                          <v-container fluid>
                    
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <v-text-field
                                  :rules="['Valid WBS Code is required']"
                                  label="Enter WBS Code"
                                  v-model="updateAccount.record.financial.wbsCode"
                                  :loading="updateAccount.record.financial.wbsValidating"
                                  :success="updateAccount.record.financial.wbsCodeValidated"
                                  :error="!updateAccount.record.financial.wbsCodeValidated"
                                  :messages="updateAccount.record.financial.wbsValidationMessage"
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  @keypress="onWbsChange"
                                  outlined
                                >
                                  <template v-slot:append>
                                    <v-btn
                                      class="my-0"
                                      small
                                      :color="updateAccount.record.financial.wbsCodeValidated ? 'orange' : ''"
                                      :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                      @click="onWbsValidate"
                                    >
                                      <span
                                        v-if="!updateAccount.record.financial.wbsCodeValidated"
                                      >validate</span>
                                      <v-icon small v-else>check</v-icon>
                                    </v-btn>
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 offset-md1 md6>
                                <v-text-field
                                  label="WBS Type"
                                  placeholder="WBS Type"
                                  v-model="updateAccount.record.financial.wbsType"
                                  messages="WBS Type shows here once WBS code is valid"
                                  disabled
                                  solo
                                />
                              </v-flex>
                              <v-flex xs12 sm6 md5>
                                <v-text-field
                                  label="Enter IWO Code"
                                  v-if="updateAccount.record.financial.wbsType == 'L-CSC-NonUS WBS'"
                                  v-model="updateAccount.record.financial.iwoCode"
                                  :loading="updateAccount.record.financial.iwoValidating"
                                  :success="updateAccount.record.financial.iwoCodeValidated"
                                  :error="!updateAccount.record.financial.iwoCodeValidated"
                                  :messages="updateAccount.record.financial.iwoValidationMessage"
                                  :disabled ="updateAccount.record.onboarding.Onboarding_Status !=='New'"
                                  @keypress="onIwoChange"
                                >
                                  <template v-slot:append>
                                    <v-btn
                                      class="my-0"
                                      small
                                      :color="updateAccount.record.financial.iwoCodeValidated ? 'orange' : ''"
                                       :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                      @click="onIwoValidate"
                                    >
                                      <span
                                        v-if="!updateAccount.record.financial.iwoCodeValidated"
                                      >validate</span>
                                      <v-icon small v-else>check</v-icon>
                                    </v-btn>
                                  </template>
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                            <!-- NOTE SECTION -->
                            <div v-if="updateAccount.fields.AWS_Req_Type !== 'Internal'">
                              <div
                                class="acknowledged-section mt-3"
                                v-bind:class="{ les: updateAccount.record.financial.wbsType == 'L-ES WBS' }"
                                v-if="updateAccount.record.financial.wbsCodeValidated"
                              >
                                <p>NOTE: Please ensure that your WBS code is set up with the correct Major Offering codes</p>
                                <p>
                                  <b>L-ES WBS Codes</b> should be aligned to
                                  <b>service line IDATD 6N</b>
                                </p>
                                <div
                                  class="wbs-agreement"
                                  v-if="updateAccount.record.financial.wbsType == 'L-ES WBS' || updateAccount.record.financial.wbsType == 'L-CSC-US WBS'"
                                >
                                  <p>
                                    To validate the major offering code using the following link. The category on the request should be WBS Lookup.
                                    <a
                                      href="https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx"
                                      target="_blank"
                                    >https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx</a>
                                  </p>
                                </div>
                                <div class="iwo-agreement" v-else>
                                  <ul>
                                    <li>GSAP WBS Codes should be aligned to Offering Portfolio – O_P1322168</li>
                                    <li>C1 WBS Codes should be under C1 Profit Center – P1322168</li>
                                    <li>
                                      To validate the C1 profit center you can look up your WBS under the here:
                                      <a
                                        href="https://myfrats.csc.com"
                                      >https://myfrats.csc.com</a>
                                    </li>
                                  </ul>
                                  <br />
                                </div>
                                <p>
                                  If your WBS Code is set up under any offering other than AWS Cloud Service (I-AWS) please work with your local finance resource to get a code set up under
                                  <b>Major Offering Code I-AWS</b>
                                </p>
                                <v-checkbox
                                  light
                                  v-model="updateAccount.record.financial.agreed"
                                  :disabled="!updateAccount.record.financial.iwoCodeValidated && updateAccount.record.financial.wbsType == 'L-CSC-NonUS WBS'"
                                  class="mx-2 confirm-validation"
                                  color="white"
                                  label="I understand and have validated that the major offering code is properly selected."
                                ></v-checkbox>
                              </div>
                            </div>
                          </v-container>
                        </div>
                      </v-stepper-content>
                      <!-- QUESTIONNAIRE SECTION -->
                      <v-stepper-content step="2">
                        <div>
                          <v-container fluid>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12 xl12>
                                <v-select
                                  :items="updateAccount.dxcRegions"
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  label="Which DXC region will this account or customer be a part of?"
                                  placeholder="Select a DXC region"
                                  v-model="updateAccount.awsOnboarding.Specific_Region"
                                ></v-select>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl12>
                                <!-- isSaas:{{updateAccount.record.onboarding.isSaas}} -->
                                <v-switch
                                 :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  v-model="updateAccount.awsOnboarding.isSaas"
                                  label="Will this workload include a DXC-owned software-based or SaaS solution where the end customer does not directly access the AWS account?"
                                  @change="isSaasOnChange()"
                                ></v-switch>
                              </v-flex>

                              <v-flex xs12 sm12 md12 xl12>
                                <v-text-field
                                 :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  v-if="updateAccount.awsOnboarding.isSaas == true"
                                  v-model="updateAccount.awsOnboarding.SaaS_Solution"
                                  label="Solution/Process Name"
                                ></v-text-field>
                              </v-flex>

                              <!-- AWS REQ Type: Internal -->
                              <v-flex xs12 sm12 md12 xl12>
                                <v-switch
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  label="Do you have AWS credits or Promo Code?"
                                  v-model="updateAccount.record.financial.isAwsCredits"
                                  v-if="updateAccount.fields.AWS_Req_Type  == 'Internal'"
                                  @change="isCreditsOnChange()"
                                ></v-switch>
                              </v-flex>

                              <v-flex xs12 sm12 md12 xl12>
                                <v-text-field
                                 :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  label="AWS Credits"
                                  v-if="updateAccount.record.financial.isAwsCredits == true"
                                  v-model="updateAccount.record.financial.awsCredits"
                                ></v-text-field>
                              </v-flex>
                              <!-- AWS REQ Type: Internal Closing tag-->
                              <v-flex xs12 sm12 md12 xl12>
                                <v-text-field
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  label="Enter Short-Name Description"
                                  v-model="updateAccount.awsOnboarding.Client_Shortname"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm12 md6 xl6>
                                <v-switch
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  v-model="updateAccount.awsOnboarding.isSpecificRegion"
                                  label="Is this account regionally restricted?"
                                ></v-switch>
                              </v-flex>

                              <v-flex xs12 sm12 md6 xl6>
                                <v-select
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  :items="updateAccount.restrictedRegions"
                                  item-text="Name"
                                  item-value="Id"
                                  label="Region"
                                  placeholder="Select a Region"
                                  v-model="updateAccount.awsOnboarding.Restricted_Region_Id"
                                  v-if="updateAccount.awsOnboarding.isSpecificRegion == true"
                                  @change="regionOnChange()"
                                ></v-select>
                              </v-flex>
                              <v-flex xs12 sm12 md6 xl6>
                                <v-switch
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  label="Is this account country restricted?"
                                  v-model="updateAccount.awsOnboarding.isSpecificLocation"
                                  @change="countryOnChange()"
                                ></v-switch>
                              </v-flex>

                              <v-flex xs12 sm12 md6 xl6>
                                <v-select
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  :items="countries"
                                  name="country"
                                  item-text="country"
                                  label="Enter Location"
                                  placeholder="Select a Country"
                                  v-model="updateAccount.awsOnboarding.Specific_Location"
                                  v-if="updateAccount.awsOnboarding.isSpecificLocation == true"
                                ></v-select>
                                <v-autocomplete
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  :items="countries"
                                  name="country"
                                  item-text="country"
                                  label="Enter Location"
                                  data-vv-validate-on="blur"
                                  cache-items
                                  flat
                                  hide-no-data
                                  hide-details
                                  attach
                                  light
                                  no-data-text="No results found"
                                  solo
                                />
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl12>
                                <v-switch
                                  label=" Will this account be subject to any regulations or laws that may restrict the nationality of DXC employees who may view information related to the account – OR – any restrictions based on specific contractual or sensitive data that may require special handling? (Note: answering Yes to this question may result in additional costs if a separate Master Payer account is required)"
                                  v-model="updateAccount.awsOnboarding.isCustomerRegulations"
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                ></v-switch>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl12>
                                <div
                                  style="background:#F1F0F0;padding:10px;font-size:13px"
                                  v-if="updateAccount.awsOnboarding.isCustomerRegulations"
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                >
                                  <v-flex>Laws and Regulations</v-flex>
                                </div>
                                <div
                                  style="background:#F1F0F0;padding:15px 25px;font-size:13px"
                                  v-if="updateAccount.awsOnboarding.isCustomerRegulations"
                                  :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                >
                                  <label>
                                    What laws or regulations require restriction for this account? Choose all applicable items. &nbsp;
                                    <i>(Please check at least one of the options)</i>
                                  </label>
                                  <v-checkbox
                                    label="GDPR"
                                    value="GDPR"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="ITAR"
                                    value="ITAR"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="FISC"
                                    value="FISC"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="HIPPA"
                                    value="HIPPA"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="US Healthcare"
                                    value="US Healthcare"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="EU citizen restricted"
                                    value="EU citizen restricted"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="US citizen restricted"
                                    value="US citizen restricted"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="UK citizen restricted"
                                    value="UK citizen restricted"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox
                                    label="Australian citizen restricted"
                                    value="Australian citizen restricted"
                                    v-model="updateAccount.awsOnboarding.Customer_Regulations"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-checkbox>
                                  <v-checkbox label="Contract Restriction"></v-checkbox>
                                  <v-text-field label="(please describe)"></v-text-field>
                                  <v-checkbox label="Other Restriction"></v-checkbox>
                                  <v-text-field label="(please describe)"></v-text-field>
                                </div>
                              </v-flex>

                              <v-flex xs12sm12 md12 xl12>
                                <v-textarea
                                  auto-grow
                                  filled
                                  label="Describe the business use for this account"
                                  rows="2"
                                  v-model="updateAccount.awsOnboarding.Acct_Description"
                                   :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                ></v-textarea>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl12>
                                <v-select
                                  :items="updateAccount.purposes"
                                  label="What is the purpose of this account?"
                                  placeholder="Choose your purpose"
                                  v-model="updateAccount.awsOnboarding.AWS_Purpose.all"
                                   :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                ></v-select>
                              </v-flex>
                              <v-flex xs1 sm12 md12 xl12>
                                <div
                                  style="background:#F1F0F0;padding:10px;font-size:13px"
                                  v-if="updateAccount.awsOnboarding.AWS_Purpose.all  === 'Proof of Concept or Prototype(POC)' "
                                   :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                >
                                  Proof of Concept and Prototype accounts have a limited lifespan and wil be automaticall suspended to prevent them becoming dormant accounts.
                                  Please answer the following questions to determine the expected duration of the account.
                                  You will be notifie at least 2 weeks prior to suspension and give the option to extend if required.
                                  <br />
                                  <br />
                                  <v-text-field
                                    label="Do you have AWS credits for this account?"
                                    v-model="updateAccount.awsOnboarding.AWS_Purpose.poc.q1"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-text-field>
                                  <v-text-field
                                    label="What is the Redemption Code?"
                                    v-model="updateAccount.awsOnboarding.AWS_Purpose.poc.q2"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                  ></v-text-field>
                                  <v-dialog
                                    ref="dialog"
                                    v-model="modal"
                                    :return-value.sync="date"
                                    persistent
                                    width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="date"
                                        label="What is the start date for this POC/Prototype?"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" scrollable>
                                      <v-spacer></v-spacer>
                                      <v-btn text color="orange" @click="modal = false">Cancel</v-btn>
                                      <v-btn text color="orange" @click="$refs.dialog.save(date)">OK</v-btn>
                                    </v-date-picker>
                                  </v-dialog>
                                  <v-dialog
                                    ref="dialog"
                                    v-model="modal"
                                    :return-value.sync="date"
                                    persistent
                                    width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="date"
                                        label="What is the expected end date for this POC/Prototype?"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" scrollable>
                                      <v-spacer></v-spacer>
                                      <v-btn text color="orange" @click="modal = false">Cancel</v-btn>
                                      <v-btn text color="orange" @click="$refs.dialog.save(date)">OK</v-btn>
                                    </v-date-picker>
                                  </v-dialog>
                                  <v-switch label="Is this POC or Prototype Client-funded?"></v-switch>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm12 md8 xl12>
                                <label>What type of Managed Services Support will this account have?</label>
                              </v-flex>
                              <v-flex xs12 sm12 md4 xl12>
                                <v-layout column align-end>
                                  <v-radio-group
                                    v-model="updateAccount.awsOnboarding.Managed_Svc"
                                     :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                    row
                                  >
                                    <v-radio label="DXC Gold" value="DXC Gold"></v-radio>
                                    <v-radio label="DXC Silver" value="DXC Silver"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md4 xl12>
                                <label>What AWS Support is required?</label>
                              </v-flex>
                              <v-flex xs12 sm12 md8 xl12>
                                <v-layout column align-end>
                                  <v-radio-group
                                   :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                    v-model="updateAccount.awsOnboarding.AWS_Support_Type"
                                    row
                                  >
                                    <v-radio label="Enterprise" value="Enterprise"></v-radio>
                                    <v-radio label="Business" value="Business"></v-radio>
                                    <v-radio label="Developer" value="Developer"></v-radio>
                                    <v-radio label="Basic" value="Basic"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </div>
                      </v-stepper-content>
                      <!-- CONTACT INFO SECTION -->
                      <v-stepper-content step="3">
                        <div>
                          <v-container>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md6 xl6>
                                <div>Account Owners:</div>
                                <div
                                  style="margin-right:25px"
                                >Enter at least 2 DXC contacts for this account. This will be DXC employees responsible for the overall AWS account. DXC eMail Distributions Lists may be used only for the second contact. The first contact must be a DXC named employee, email, and phone.</div>
                              </v-flex>
                              <v-flex xs12 sm12 md6 xl6>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12 xl12>
                                    <v-text-field
                                      class="centered-input"
                                      placeholder="Name"
                                      label="Name"
                                      v-model="updateAccount.awsAccountContact.acctOwner.name"
                                       :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6 xl6>
                                    <v-text-field
                                      class="centered-input"
                                      placeholder="Phone Number"
                                      label="Phone Number"
                                      v-model="updateAccount.awsAccountContact.acctOwner.phone"
                                       :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6 xl6>
                                    <v-text-field
                                      class="centered-input"
                                      placeholder="Email Address"
                                      label="Email Address"
                                      v-model="updateAccount.awsAccountContact.acctOwner.email"
                                       :disabled ="updateAccount.fields.Onboarding_Status !=='New'"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12 xl12>
                                    <v-layout align-top justify-end style="margin-top:-25px">
                                      <v-btn class="opp-btn" color="warning"  :disabled ="updateAccount.fields.Onboarding_Status !=='New'" @click="add">Add Account Owner</v-btn>
                                      <!-- <v-btn class="opp-btn" color="warning">Show Account Owner</v-btn> -->
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl12>
                                <div style="background:#F1F0F0;padding:10px;margin-bottom:15px;font-size:13px">
                                     <v-dialog v-model="dialog" max-width="500px">
                                      <v-card>
                                        <v-card-text>
                                          <v-container grid-list-md>
                                            <v-layout wrap>
                                              <v-flex xs12 sm12 md12 xl12>
                                                <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                                              </v-flex>
                                              <v-flex xs12 sm12 md12 xl12>
                                                <v-text-field v-model="editedItem.phone" label="Phone"></v-text-field>
                                              </v-flex>
                                              <v-flex xs12 sm6 md4 xl12>
                                                <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                                          <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>
                                  <v-data-table
                                    :headers="updateAccount.accountOwners"
                                    :items="updateAccount.awsAccountContact.Account_Owners"
                                    :items-per-page="2"
                                    class="elevation-1"
                                  >
                                    <template v-slot:items="props">
                                      <td class="">
                                        <v-icon small class="mr-2"  :disabled ="updateAccount.fields.Onboarding_Status !=='New'" @click="editItem(props.item)">edit</v-icon>
                                        <v-icon small  :disabled ="updateAccount.fields.Onboarding_Status !=='New'" @click="deleteItem(props.item)">delete</v-icon>
                                      </td>
                                      <td>{{ props.item.name }}</td>
                                      <td>{{ props.item.phone }}</td>
                                      <td>{{ props.item.email}}</td>
                                    </template>
                                  <template v-slot:no-data>
                                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                                  </template>   
                                  </v-data-table>
                                </div>
                              </v-flex>

                               <v-flex xs12 sm12 md6 xl6>
                                <label>Please provide a list of users who will receive notifications from AWS on account</label>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl6>
                                <template>
                                  <v-combobox v-model="updateAccount.awsAccountContact.Notification_List"
                                              label="Emails"
                                              chips
                                              clearable
                                              solo
                                              :rules="emailRules"
                                              multiple>
                                      <template v-slot:selection="data">
                                          <v-chip :selected="data.selected"
                                                  close
                                                  @input="notificationListRemove(data.item)">
                                              <strong>{{ data.item }}</strong>&nbsp;
                                          </v-chip>
                                      </template>
                                  </v-combobox>
                              </template>
                              </v-flex>
                               
                               <v-flex xs12 sm12 md6 xl6 v-if="updateAccount.awsOnboarding.Managed_Svc !=='DXC Gold'">
                                <label>Please provide a list of users for the account who need Admin access:</label>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl6 v-if="updateAccount.awsOnboarding.Managed_Svc !=='DXC Gold'">
                                <template>
                                  <v-combobox v-model="updateAccount.awsAccountContact.IAM_Users"
                                              label="Emails"
                                              chips
                                              clearable
                                              solo
                                              :rules="emailRules"
                                              multiple>
                                      <template v-slot:selection="data">
                                          <v-chip :selected="data.selected"
                                                  close
                                                  @input="iAmUsersRemove(data.item)">
                                              <strong>{{ data.item }}</strong>&nbsp;
                                          </v-chip>
                                      </template>
                                  </v-combobox>
                              </template>
                              </v-flex>


                              <v-flex xs12 sm12 md6 xl6>
                                <label>Who is the financial owner of the AWS account (owner of WBS / IWO associated with it)?</label>
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl6>
                                <template>
                                  <v-combobox v-model="updateAccount.awsAccountContact.Financial_Owner"
                                              label="Emails"
                                              chips
                                              clearable
                                              solo
                                              :rules="emailRules"
                                              multiple>
                                      <template v-slot:selection="data">
                                          <v-chip :selected="data.selected"
                                                  close
                                                  @input="financeOwnersRemove(data.item)">
                                              <strong>{{ data.item }}</strong>&nbsp;
                                          </v-chip>
                                      </template>
                                  </v-combobox>
                              </template>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </div>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions style="text-align: right">
          <v-spacer />
          <v-btn @click.stop="updateAccount.showDialog = false">Close</v-btn>
          <v-btn :disabled="!updateAccount.record.financial.wbsCodeValidated" color="orange" :loading="updateAccount.saving" v-if="updateAccount.fields.Onboarding_Status === 'New'" @click="updateAwsRequest">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- CLONE MODAL  -->
    <v-dialog v-model="cloneRecord.cloneDialog" persistent scrollable max-width="800px">
      <v-card style="padding:20px 0"> 
      <v-container fluids>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 xl12>
           <v-text-field label="Account Name" 
           v-model="cloneRecord.awsOnboarding.Acct_name"
           disabled></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12 xl12>
           <v-btn v-model="cloneRecord.add" @click="clone">Add Clone</v-btn>
           <v-btn v-model="cloneRecord.add" @click="viewClone">View Clone</v-btn>
        </v-flex>
          <v-container v-if="cloneRecord.add === true" style=" padding-top:25px">
              <h3 v-if="cloneRecord.addForm === false">{{cloneRecord.addMessage}}</h3>
              <div v-if="cloneRecord.addForm === true">
                <v-text-field label="Account Name"  v-model="generateCloneAccountName" read-only></v-text-field>
                <v-text-field label="Shortname"  v-model="cloneRecord.shortName"></v-text-field>
                <v-layout row wrap>
                  <v-flex xs12 sm 12 md6 xl6>
                     <v-switch
                        v-model="cloneRecord.isSpecificRegion"
                        label="Is this account regionally restricted?"
                      ></v-switch>
                  </v-flex>
                   <v-flex xs12 sm12 md6 xl6>
                      <v-select
                        :items="updateAccount.restrictedRegions"
                        item-text="Name"
                        item-value="Id"
                        label="Region"
                        placeholder="Select a Region"
                        v-model="cloneRecord.Restricted_Region_Id"
                        v-if="cloneRecord.isSpecificRegion === true"
                        @change="cloneRegionOnChange()"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md6 xl6>
                      <v-switch
                        label="Is this account country restricted?"
                        v-model="cloneRecord.isSpecificLocation"
                        @change="cloneCountryOnChange()"
                      ></v-switch>
                    </v-flex>
                      <v-flex xs12 sm12 md6 xl6>
                           <v-autocomplete
                            :items="countries"
                            name="country"
                            item-text="country"
                            label="Select a Country"
                            data-vv-validate-on="blur"
                            cache-items
                            flat
                            hide-no-data
                            hide-details
                            attach
                            light
                            no-data-text="No results found"
                            v-model="cloneRecord.Specific_Location"
                            v-if="cloneRecord.isSpecificLocation === true"
                            solo
                          />
                    </v-flex>
                    <v-flex xs12 sm12 md12 xl12>
                      <v-select
                      :items="updateAccount.purposes"
                      label="What is the purpose of this account?"
                      placeholder="Choose your purpose"
                      v-model= "cloneRecord.purpose"
                      ></v-select>
                    </v-flex>
                </v-layout>
               
                             

                              
                <v-btn color="warning" @click="addtoBulk">Add</v-btn>
              </div>
          </v-container>
          <v-container v-if="cloneRecord.view === true" style="padding-top:25px">
           
             <v-data-table
              :headers="cloneRecord.bulkCloneHeaders"
              :items="cloneRecord.bulkRecords"
              no-data-text="No workload available"
              disable-initial-sort
            >
            <template v-slot:items="props">
              <tr :active="props.selected">
                <td>{{ props.item.accountname }}</td>
                <td>{{ props.item.shortname }}</td>
              </tr>
            </template>
             </v-data-table>
             <v-btn  color="warning"  @click="cloneAllRecords">Clone All Records</v-btn>
          </v-container>
        
      </v-layout>
      </v-container>
     
      </v-card>
    </v-dialog>
  </div>

  <!-- Update Request AWS Acct Dialog -->
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { getCountries } from "@/utils/helper";
import FinanceMonthlyCrossChargeVue from '../../admin/financeAdmin/FinanceMonthlyCrossCharge.vue';

export default {
  data () {
    return {
      e1: 0,
      location: null,
      countryCode: null,
      countries: getCountries(),
      selected: [],
      headers: ["Account_ID", "Account_Name", "Onboarding Status"],
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      // account owners
      dialog: false,
        editedIndex: -1,
      editedItem: {
        name: '',
        phone: '',
        email: ''
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      },
      chips: [],
          emailRules :[
      v => {
        if (!v || v.length < 1)
          return 'Input is required';
        else if (v.length > 0) {
          for (let i = 0; i < v.length; i++) {
                if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Input must be valid email format';
              }
            }
          }
        else return true;
      }
    ],
    notificationList: [],
    iAmUsers: [],
    financeOwners:[],
    };
  },
  mounted() {
    this.$store.dispatch("user/listAws/getOnboardingRequests");
    this.$store.dispatch("user/listAws/getRestrictedRegions");
  },
  computed: {
    ...mapState("user/listAws", [
      "onboardingRequests",
      "onboardingRequestsHeaders",
      "loadingRequest",
      "cloneRecord",
      "updateAccount", 
  
    ]),

    generateAcctName() {
      let acctName = this.updateAccount.awsOnboarding.Acct_name;
      if (acctName !== null) {
        let acctType = acctName.substring(0, 7);
        let custShortname = this.updateAccount.awsOnboarding.Cust_Shortname;
        let shortName = this.updateAccount.awsOnboarding.Client_Shortname;
        let primaryPurpose = this.updateAccount.awsOnboarding.AWS_Purpose
          .all;
        let awsPurpose;
        // Account Purpose
        if (primaryPurpose == "Production(Prod)") {
          awsPurpose = "-prod";
        } else if (primaryPurpose === "Staging(Stage)") {
          awsPurpose = "-stage";
        } else if (primaryPurpose === "Quality Assurance (QA)") {
          awsPurpose = "-qa";
        } else if (primaryPurpose === "Development (Dev)") {
          awsPurpose = "-dev";
        } else if (primaryPurpose === "Test (Test)") {
          awsPurpose = "-test";
        } else if (primaryPurpose === "Proof of Concept or Prototype(POC)") {
          awsPurpose = "-poc";
        } else if (primaryPurpose === "Demonstration (Demo)") {
          awsPurpose = "-demo";
        } else if (
          primaryPurpose === "Sandbox (SB)" ||
          primaryPurpose === "Training"
        ) {
          awsPurpose = "-sandbox";
        } else {
          awsPurpose = "";
        }

        // IF specific_region === true AND specific_location  === true THEN put ISO Code of the country
        // ELSE IF specific_region === true AND specific_location  === false THEN put region

        let isRegion = this.updateAccount.awsOnboarding.isSpecificRegion;
        let isLocationSpecific = this.updateAccount.awsOnboarding.isSpecificLocation;

        let specificRegion = this.updateAccount.awsOnboarding.Restricted_Region_Id;
        let specificLocation = this.updateAccount.awsOnboarding.Specific_Location;

        let isoCode = this.countries.filter(res => {
          if (
            res.country == this.updateAccount.awsOnboarding.Specific_Location
          ) {
            return res.code;
          }
        });
        if (isoCode.length > 0) {
          this.countryCode = isoCode[0].code;
        }
        console.log("isRegion? ", isRegion);
        console.log("isRegion? ", isLocationSpecific);
        console.log("specificLocation: ", specificLocation);
        console.log(isRegion && isLocationSpecific);

        if (isRegion && !isLocationSpecific) {
          let resRegionName = this.updateAccount.restrictedRegions.filter(
            reg => reg.Id == specificRegion
          );
          console.log("resRegionName " + resRegionName[0].Name);
          this.location = "-" + resRegionName[0].Name;
        } else if (!isRegion && isLocationSpecific) {
          if (
            specificLocation !== "" ||
            specificLocation !== null ||
            specificLocation !== "None"
          ) {
            this.location = "-" + this.countryCode;
            console.log('location is equal to country code: '+ this.location)
          }
          if (specificLocation === "") {
            this.location = "";
          }
        } else if (isRegion && isLocationSpecific) {
          console.log("a");

          if (
            specificLocation !== "" ||
            specificLocation !== null ||
            specificLocation !== "None"
          ) {
            this.location = "-" + this.countryCode;
          }
          if (specificLocation === "") {
            this.location = "";
          }
        } else if (!isRegion && !isLocationSpecific) {
          this.location = "";
        }
        let loc =
          this.location !== null || this.location !== "" ? this.location : "";
        console.log("FinalLocation: ", loc);
        let regenAcctName =
          acctType +
          "-" +
          custShortname.replace(/\s+/g, "") +
          "-" +
          shortName.replace(/[^A-Z0-9]/gi, "") +
          awsPurpose +
          loc;
        this.updateAccount.awsOnboarding.Acct_name = regenAcctName.toUpperCase();
        return regenAcctName.toUpperCase();
      }
    },
    generateCloneAccountName(){
      let shortname= "-"+this.cloneRecord.shortName
       let primaryPurpose = this.cloneRecord.purpose;
        let awsPurpose;
        // Account Purpose
        if (primaryPurpose == "Production(Prod)") {
          awsPurpose = "-prod";
        } else if (primaryPurpose === "Staging(Stage)") {
          awsPurpose = "-stage";
        } else if (primaryPurpose === "Quality Assurance (QA)") {
          awsPurpose = "-qa";
        } else if (primaryPurpose === "Development (Dev)") {
          awsPurpose = "-dev";
        } else if (primaryPurpose === "Test (Test)") {
          awsPurpose = "-test";
        } else if (primaryPurpose === "Proof of Concept or Prototype(POC)") {
          awsPurpose = "-poc";
        } else if (primaryPurpose === "Demonstration (Demo)") {
          awsPurpose = "-demo";
        } else if (
          primaryPurpose === "Sandbox (SB)" ||
          primaryPurpose === "Training"
        ) {
          awsPurpose = "-sandbox";
        } else {
          awsPurpose = "";
        }

      // IF specific_region === true AND specific_location  === true THEN put ISO Code of the country
        // ELSE IF specific_region === true AND specific_location  === false THEN put region

        let isRegion = this.cloneRecord.isSpecificRegion;
        let isLocationSpecific = this.cloneRecord.isSpecificLocation;

        let specificRegion = this.cloneRecord.Restricted_Region_Id;
        let specificLocation = this.cloneRecord.Specific_Location;

        console.log('isRegion: ', isRegion)
        console.log('isLocationSpecific: ', isLocationSpecific)
        console.log('specificRegion: ', specificRegion)
        console.log('specificLocation: ', specificLocation)

        let isoCode = this.countries.filter(res => {
          if (
            res.country == this.cloneRecord.Specific_Location
          ) {
            return res.code;
          }
        });
        if (isoCode.length > 0) {
          this.countryCode = isoCode[0].code;
        }
        console.log("isRegion? ", isRegion);
        console.log("isRegion? ", isLocationSpecific);
        console.log("specificLocation: ", specificLocation);
        console.log(isRegion && isLocationSpecific);

        if (isRegion && !isLocationSpecific) {
          if(specificRegion !== ''){
             let resRegionName =  this.updateAccount.restrictedRegions.filter( reg => reg.Id === specificRegion)
       
           console.log('selected Region Name:::: ', resRegionName[0]['Name'])
            this.location = "-" + resRegionName[0]['Name']
          }
         
        } else if (!isRegion && isLocationSpecific) {
          if (
            specificLocation !== "" ||
            specificLocation !== null ||
            specificLocation !== "None"
          ) {
            this.location = "-" + this.countryCode;
          }
          if (specificLocation === "") {
            this.location = "";
          }
        } else if (isRegion && isLocationSpecific) {
          console.log("a");

          if (
            specificLocation !== "" ||
            specificLocation !== null ||
            specificLocation !== "None"
          ) {
            this.location = "-" + this.countryCode;
          }
          if (specificLocation === "") {
            this.location = "";
          }
        } else if (!isRegion && !isLocationSpecific) {
          this.location = "";
        }
        let loc =
          this.location !== null || this.location !== "" ? this.location : "";
        console.log("FinalLocation: ", loc);
    console.log('--------awsPurpose------')
    console.log(awsPurpose)
    console.log ('-----------------------')
      let regenAcctName= this.cloneRecord.acctName+shortname+awsPurpose+loc
      console.log('montesssst')
      console.log('regeeeeen::: '+ regenAcctName)
      return regenAcctName.toUpperCase();
    }
  },
  

  watch: {
      dialog (val) {
        val || this.close()
      }
    },

  methods: {
    onEditOnboardingAccount(record) {
      this.$store.commit("user/listAws/showUpdateDialog", record);
    },
    cloneAccount(record) {
      this.$store.commit("user/listAws/showCloneAccountDialog", record)
    },
    viewClone(){
      this.cloneRecord.view = true
      this.cloneRecord.add = false
    },
    clone(record) {
      if(this.cloneRecord.add){
        this.cloneRecord.add = false
      } else {
        this.cloneRecord.view = false
        this.cloneRecord.add = true
        let namee = "AWS-PPA-DXCHHS-BONTEST41520201-STAGE-ANZ"
        let countryCode = namee.split('-').pop()
        console.log('countryCode: ', countryCode)
        let trimAcctNameCountryCode = namee.replace('-'+countryCode, "")
        let purpose = trimAcctNameCountryCode.split('-').pop()
        let trimAcctNamePurpose = trimAcctNameCountryCode.replace('-'+purpose, "")
        let shortname = trimAcctNamePurpose.split('-').pop()
        let trimAcctNameShortname = trimAcctNamePurpose.replace('-'+shortname,"")
        console.log('trimAcctNameCountryCode::  ', trimAcctNameCountryCode)
        console.log('purpose:: ', purpose)
        console.log('trimAcctNamePurpose:: ', trimAcctNamePurpose)
        console.log("shortname:: ", shortname )
        console.log('trimAcctNameShortname:: ', trimAcctNameShortname)
        // this.$store.commit("user/listAws/addClone", record)
        let acctNameObj = {
          accountname: trimAcctNameShortname,
          purpose: purpose,
          countrycode: countryCode,
          addFormStatus: true
        }
        this.$store.commit("user/listAws/addClone", acctNameObj)
      }
    },
    addtoBulk(record){
      console.log('------ addtoBulk -------')
      console.log('generate cloned account name:: ', this.generateCloneAccountName)
      console.log('client shortname: ', this.cloneRecord.shortName)
      console.log('------------------------')
      let message = 'Onboarding Account Name has been added.'
      let cloneOnboarding = {
        accountname: this.generateCloneAccountName,
        shortname: this.cloneRecord.shortName,
      }
      this.$store.commit("user/listAws/addOnboardingClone", { record: cloneOnboarding , message:message, addFormStatus: false , viewFormStatus:true})
    },

    onWbsChange() {
      this.updateAccount.record.financial.wbsCodeValidated = false;
      this.updateAccount.record.financial.wbsValidationMessage = "";
    },
    onWbsValidate() {
      this.$store.dispatch("user/listAws/validateWbsCode",this.updateAccount.record.financial.wbsCode);
    },
    onIwoChange() {
      this.updateAccount.record.financial.iwoCodeValidated = false;
      this.updateAccount.record.financial.iwoValidationMessage = "";
    },
    onIwoValidate() {
      this.$store.dispatch(
        "user/listAws/validateIwoCode",
        this.updateAccount.record.financial.iwoCode
      );
    },
    isSaasOnChange() {
      let isSaas = this.updateAccount.awsOnboarding.isSaas;
      if (!isSaas) {
        this.updateAccount.awsOnboarding.SaaS = "No";
        this.updateAccount.awsOnboarding.SaaS_Solution = "None";
      } else {
        this.updateAccount.awsOnboarding.SaaS = "Yes";
      }
    },
    isCreditsOnChange() {
      let isAwsCredits = this.updateAccount.record.financial.isAwsCredits;
      if (!isAwsCredits) {
        this.updateAccount.record.financial.awsCredits = "";
      }
    },

    regionOnChange() {
      let isRegionRestricted = this.countryCodeupdateAccount.awsOnboarding.isSpecificRegion;
      if (!isRegionRestricted) {
        this.updateAccount.awsOnboarding.Restricted_Region_Id = "";
      }
    },
    countryOnChange() {
      let isCountryRestricted = this.updateAccount.awsOnboarding.isSpecificLocation;
      if (!isCountryRestricted) {
        this.updateAccount.awsOnboarding.Specific_Location = "";
      }
    },

    cloneRegionOnChange() {
      // alert('clone Region On Change')
      console.log('isSpecificRegion Status: ', this.cloneRecord.isSpecficRegion)
      let isRegionRestricted = this.cloneRecord.isSpecificRegion;
      if (!isRegionRestricted) {
        this.cloneRecord.Restricted_Region_Id = "";
      }
    },
    cloneCountryOnChange() {
      let isCountryRestricted = this.cloneRecord.isSpecificLocation;
      if (!isCountryRestricted) {
        this.cloneRecord.Specific_Location = "";
      }
    },

    add(){
     let acctOwnerObject = {
        name: this.updateAccount.awsAccountContact.acctOwner.name, 
        phone: this.updateAccount.awsAccountContact.acctOwner.phone,
        email: this.updateAccount.awsAccountContact.acctOwner.email
      }
     
     let accountOwnerArray  =  this.updateAccount.awsAccountContact.Account_Owners
      
     let isAccountOwnerExists = accountOwnerArray.filter( res => {
        return res.email === this.updateAccount.awsAccountContact.acctOwner.email
      })
      

      if(isAccountOwnerExists.length === 0) {
        accountOwnerArray.push(acctOwnerObject)
        this.updateAccount.awsAccountContact.acctOwner.name =''
        this.updateAccount.awsAccountContact.acctOwner.phone =''
        this.updateAccount.awsAccountContact.acctOwner.email =''
      } else {
        this.$store.commit(
        "showDialog",
        {
          show: true,
          type: "alert",
          persistent: true,
          title: "Email Already Exists!"
        },
        { root: true }
      );
      }
      
      this.updateAccount.awsAccountContact.acctOwner.name =''
      this.updateAccount.awsAccountContact.acctOwner.phone =''
      this.updateAccount.awsAccountContact.acctOwner.email =''
      
    },
   editItem (item) {
        this.editedIndex = this.updateAccount.awsAccountContact.Account_Owners.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    },
    deleteItem (item) {
        const index = this.updateAccount.awsAccountContact.Account_Owners.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.updateAccount.awsAccountContact.Account_Owners.splice(index, 1)
      },
       close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.updateAccount.awsAccountContact.Account_Owners[this.editedIndex], this.editedItem)
        } else {
          this.updateAccount.awsAccountContact.Account_Owners.push(this.editedItem)
        }
        this.close()
      },
    removeInvoiceOwner(item){
        this.updateAccount.awsAccountContact.Invoice_DL.splice(this.updateAccount.awsAccountContact.Invoice_DL.indexOf(item), 1)
        this.updateAccount.awsAccountContact.Invoice_DL = [...this.updateAccount.awsAccountContact.Invoice_DL]
    },
    updateAwsRequest() {
      if(this.updateAccount.awsOnboarding.AWS_Purpose.all !== 'Proof of Concept or Prototype(POC)'){
        this.updateAccount.awsOnboarding.AWS_Purpose.poc.q1 = ''
        this.updateAccount.awsOnboarding.AWS_Purpose.poc.q2 = ''
        this.updateAccount.awsOnboarding.AWS_Purpose.poc.q3 = ''
        this.updateAccount.awsOnboarding.AWS_Purpose.poc.q4 = ''
        this.updateAccount.awsOnboarding.AWS_Purpose.poc.q5 = ''
      }
      let acctPurposeObj = {
        all: this.updateAccount.awsOnboarding.AWS_Purpose.all,
        poc: {
          q1: this.updateAccount.awsOnboarding.AWS_Purpose.poc.q1,
          q2: this.updateAccount.awsOnboarding.AWS_Purpose.poc.q2,
          q3: this.updateAccount.awsOnboarding.AWS_Purpose.poc.q3,
          q4: this.updateAccount.awsOnboarding.AWS_Purpose.poc.q4,
          q5: this.updateAccount.awsOnboarding.AWS_Purpose.poc.q5
        }
      }
      this.updateAccount.awsOnboarding.Account_Purpose = JSON.stringify(acctPurposeObj)
      this.$store.commit("user/listAws/updateAccountRecord", this.updateAccount);
      this.$store.commit("user/listAws/updateOnboardingContacts", { 
        notificationList: this.updateAccount.awsAccountContact.Notification_List, 
        iAmUsers: this.updateAccount.awsAccountContact.IAM_Users, 
        financeOwners: this.updateAccount.awsAccountContact.Financial_Owner 
      })
      this.$store.dispatch("user/listAws/updateAwsRequest",this.updateAccount.fields);
    }, 

    // chips COMBO BOX
    notificationListRemove(item) {
                this.updateAccount.awsAccountContact.Notification_List.splice(this.updateAccount.awsAccountContact.Notification_List.indexOf(item), 1)
                this.updateAccount.awsAccountContact.Notification_List = [...this.updateAccount.awsAccountContact.Notification_List]
            },

    iAmUsersRemove(item) {
                this.updateAccount.awsAccountContact.IAM_Users.splice(this.updateAccount.awsAccountContact.IAM_Users.indexOf(item), 1)
                this.updateAccount.awsAccountContact.IAM_Users = [...this.updateAccount.awsAccountContact.IAM_Users]
            },
    financeOwnersRemove(item) {
                this.updateAccount.awsAccountContact.Financial_Owner.splice(this.updateAccount.awsAccountContact.Financial_Owner.indexOf(item), 1)
                this.updateAccount.awsAccountContact.Financial_Owner  = [...this.updateAccount.awsAccountContact.Financial_Owner]
            },
  }
};
</script>

<style lang="scss" scoped>
.acknowledged-section {
  padding: 20px;
  background: #ff9900;

  &.les {
    background: yellow;
  }

  a {
    color: #000;
    text-decoration: underline;
  }
}

.confirm-validation {
  label {
    color: #000 !important;
    font-weight: 500 !important;
  }
}
</style>
